import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5332">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5333">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5334">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5335">
            <ArrowLeft className="w-4 h-4" data-id="element-5336" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5337">NOIZA</div>
          <div className="w-20" data-id="element-5338" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5339">
        <div className="mb-12" data-id="element-5340">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5341">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5342" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5343">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5344">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5345">
          <section data-id="element-5346">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5347">
              <span className="text-[#006847]" data-id="element-5348">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5349">
              <p data-id="element-5350">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5351">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5352">
                <li data-id="element-5353">Haber leído íntegramente este documento</li>
                <li data-id="element-5354">Comprender su contenido en su totalidad</li>
                <li data-id="element-5355">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5356">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5357">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5358">
              <span className="text-[#006847]" data-id="element-5359">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5360">
              <p data-id="element-5361">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5362">
                <li data-id="element-5363">Software como servicio (SaaS)</li>
                <li data-id="element-5364">Marketplace digital gastronómico</li>
                <li data-id="element-5365">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5366">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5367">
                <li data-id="element-5368">Mostrar su menú digital</li>
                <li data-id="element-5369">Recibir pedidos de clientes</li>
                <li data-id="element-5370">Gestionar su operación interna</li>
                <li data-id="element-5371">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5372">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5373">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5374">
              <span className="text-[#006847]" data-id="element-5375">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5376">
              <p data-id="element-5377">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5378">
                <li data-id="element-5379">No es proveedor de alimentos</li>
                <li data-id="element-5380">No participa en la preparación de productos</li>
                <li data-id="element-5381">No manipula alimentos en ningún momento</li>
                <li data-id="element-5382">No realiza entregas ni logística</li>
                <li data-id="element-5383">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5384">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5385">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5386">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5387">
              <span className="text-[#006847]" data-id="element-5388">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5389">
              <p data-id="element-5390">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5391">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5392">
                <li data-id="element-5393">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5394">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5395">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5396">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5397">
                <li data-id="element-5398">Precios</li>
                <li data-id="element-5399">Menú</li>
                <li data-id="element-5400">Horarios</li>
                <li data-id="element-5401">Métodos de pago</li>
                <li data-id="element-5402">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5403">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5404">
              <span className="text-[#006847]" data-id="element-5405">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5406">
              <div data-id="element-5407">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5408">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5409">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5410">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5411">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5412">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5413">
                  <li data-id="element-5414">Calidad de los alimentos</li>
                  <li data-id="element-5415">Estado, frescura o preparación</li>
                  <li data-id="element-5416">Ingredientes utilizados</li>
                  <li data-id="element-5417">Contaminación cruzada</li>
                  <li data-id="element-5418">Problemas de higiene o salubridad</li>
                  <li data-id="element-5419">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5420">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5421">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5422">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5423">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5424">
                  <li data-id="element-5425">Retrasos en la entrega</li>
                  <li data-id="element-5426">Pérdida de pedidos</li>
                  <li data-id="element-5427">Entregas incompletas</li>
                  <li data-id="element-5428">Errores en dirección</li>
                  <li data-id="element-5429">Conducta de repartidores</li>
                  <li data-id="element-5430">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5431">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5432">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5433">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5434">
                  <li data-id="element-5435">Recepción de pagos</li>
                  <li data-id="element-5436">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5437">Manejo de efectivo</li>
                  <li data-id="element-5438">Confirmación de pagos</li>
                  <li data-id="element-5439">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5440">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5441">
                  <li data-id="element-5442">Pagos no recibidos</li>
                  <li data-id="element-5443">Comprobantes falsos</li>
                  <li data-id="element-5444">Errores en montos</li>
                  <li data-id="element-5445">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5446">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5447">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5448">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5449">
                  <li data-id="element-5450">Reclamos de clientes</li>
                  <li data-id="element-5451">Reembolsos</li>
                  <li data-id="element-5452">Cancelaciones</li>
                  <li data-id="element-5453">Disputas</li>
                  <li data-id="element-5454">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5455">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5456">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5457">
              <span className="text-[#006847]" data-id="element-5458">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5459">
              <p data-id="element-5460">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5461">
                <li data-id="element-5462">Responsable</li>
                <li data-id="element-5463">Legal</li>
                <li data-id="element-5464">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5465">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5466">
                <li data-id="element-5467">Publicar información falsa</li>
                <li data-id="element-5468">Manipular precios de forma engañosa</li>
                <li data-id="element-5469">Simular disponibilidad inexistente</li>
                <li data-id="element-5470">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5471">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5472">
              <span className="text-[#006847]" data-id="element-5473">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5474">
              <p data-id="element-5475">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5476">
                <li data-id="element-5477">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5478">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5479">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5480">
                <li data-id="element-5481">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5482">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5483">
                    <li data-id="element-5484">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5485">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5486">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5487">
              <span className="text-[#006847]" data-id="element-5488">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5489">
              <p data-id="element-5490">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5491">
                <li data-id="element-5492">Menú digital</li>
                <li data-id="element-5493">Gestión de pedidos</li>
                <li data-id="element-5494">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5495">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5496">
                  <p className="font-medium text-white mb-2" data-id="element-5497">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5498">
                    <li data-id="element-5499">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5500">
                  <p className="font-medium text-white mb-2" data-id="element-5501">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5502">
                    <li data-id="element-5503">Propiedad del software</li>
                    <li data-id="element-5504">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5505">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5506">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5507">
              <span className="text-[#006847]" data-id="element-5508">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5509">
              <p data-id="element-5510">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5511">
                <li data-id="element-5512">Disponibilidad continua</li>
                <li data-id="element-5513">Funcionamiento sin interrupciones</li>
                <li data-id="element-5514">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5515">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5516">
                <li data-id="element-5517">Fallas técnicas</li>
                <li data-id="element-5518">Actualizaciones</li>
                <li data-id="element-5519">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5520">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5521">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5522">
              <span className="text-[#006847]" data-id="element-5523">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5524">
              <p data-id="element-5525">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5526">
                <li data-id="element-5527">No está garantizada permanentemente</li>
                <li data-id="element-5528">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5529">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5530">
                <li data-id="element-5531">Destacar o no restaurantes</li>
                <li data-id="element-5532">Modificar posiciones</li>
                <li data-id="element-5533">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5534">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5535">
              <span className="text-[#006847]" data-id="element-5536">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5537">
              <p data-id="element-5538">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5539">
                <li data-id="element-5540">Cumplir con los pagos acordados</li>
                <li data-id="element-5541">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5542">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5543">
                <li data-id="element-5544">Suspender el servicio</li>
                <li data-id="element-5545">Limitar funcionalidades</li>
                <li data-id="element-5546">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5547">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5548">
              <span className="text-[#006847]" data-id="element-5549">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5550">
              <p data-id="element-5551">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5552">
                <li data-id="element-5553">Incumplimiento de términos</li>
                <li data-id="element-5554">Uso indebido</li>
                <li data-id="element-5555">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5556">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5557">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5558">
              <span className="text-[#006847]" data-id="element-5559">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5560">
              <p data-id="element-5561">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5562">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5563">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5564">
              <span className="text-[#006847]" data-id="element-5565">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5566">
              <p data-id="element-5567">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5568">
                <li data-id="element-5569">Pérdidas económicas</li>
                <li data-id="element-5570">Daños indirectos</li>
                <li data-id="element-5571">Lucro cesante</li>
                <li data-id="element-5572">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5573">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5574">
              <span className="text-[#006847]" data-id="element-5575">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5576">
              <p data-id="element-5577">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5578">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5579">
              <span className="text-[#006847]" data-id="element-5580">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5581">
              <p className="font-medium" data-id="element-5582">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5583">
                <li data-id="element-5584">Ha leído este documento completo</li>
                <li data-id="element-5585">Comprende su alcance</li>
                <li data-id="element-5586">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}